import React from "react";
import PropTypes from "prop-types";
import { Header, Grid, Label } from "semantic-ui-react";

export const PaymentDetails = ({
  selectedPatron,
  calculatedTotal,
  isUsingOverrides,
}) => {
  const originalTotal = selectedPatron.totalFine || 0;
  const hasActualOverride =
    isUsingOverrides && calculatedTotal !== originalTotal;

  return (
    <div className="payment-details">
      <Header as="h4">Payment Details</Header>
      <Grid columns={4} stackable>
        <Grid.Column>
          <div className="payment-info-card">
            <div className="card-label">Patron</div>
            <div className="card-value">{selectedPatron.name}</div>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="payment-info-card">
            <div className="card-label">
              {isUsingOverrides ? "Original Fine" : "Total Available Fine"}
            </div>
            <div className="card-value fine-amount">
              ₱{originalTotal.toFixed(2)}
              {isUsingOverrides && (
                <Label size="mini" color="grey">
                  ORIGINAL
                </Label>
              )}
            </div>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="payment-info-card selected-amount">
            <div className="card-label">Amount to Pay</div>
            <div className="card-value selected">
              ₱{calculatedTotal.toFixed(2)}
              {hasActualOverride && (
                <Label size="mini" color="orange">
                  OVERRIDE
                </Label>
              )}
            </div>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="payment-info-card">
            <div className="card-label">Total Overdue Books</div>
            <div className="card-value">{selectedPatron.overdueCount}</div>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

PaymentDetails.propTypes = {
  selectedPatron: PropTypes.object.isRequired,
  calculatedTotal: PropTypes.number.isRequired,
  isUsingOverrides: PropTypes.bool.isRequired,
};
